<script>
import { onMounted,provide,reactive, ref } from 'vue';
import { useRoute } from "vue-router";

//composable
import LandingFlow from "../composable/LandingFlow";
//controller

//component
import Picture from '../component/History/Picture.vue';
import DetailInfo from '../component/History/DetailInfo.vue';
import SerialDetail from '../component/History/showCode/SerialDetail.vue';
import Serial from '../component/History/showCode/Serial.vue';
import SerialCode from '../component/History/showCode/SerialCode.vue';
import { useTheme } from '../composable/IimpactTheme';
//Feature
import { useLocale } from '@/feature/LocaleFeature'
//store
import useModalStore from "../store/ModalStore";
//modal
import ModalMaster from "../modal/ModalMaster.vue";
import { useModalSetup } from '../modal/useModalSetup'

export default {
    components: {
        ModalMaster,
        Picture,
        DetailInfo,
        SerialDetail,
        Serial,
        SerialCode
    },
    setup: function () {
        useTheme()
        const { switchLang, lbl } = useLocale()
        const route = useRoute()

        const ModalStore = useModalStore()
        const { initModal } = useModalSetup(ModalStore)
        const modal = initModal();
        const isError = ref(false);
        const title = ref(lbl.iimmpact.history.title)

        const landingFlow = LandingFlow({
            mainAppName: "iimmpact"
        })


        let immpact = reactive({
            isLoaded: false,
        })

        const init = () => {
            // start initial
            modal.loadingModal.show()
            landingFlow.init()
            landingFlow.events.onError = (err) => {
                console.log("init error", err)
                modal.loadingModal.hide()
                isError.value = true
                title.value = lbl.iimmpact.error.title
            }
            landingFlow.events.onReady = () => {
                modal.loadingModal.hide()

                immpact.isLoaded = true;
                console.log("isPageReady", landingFlow.states)
            }
        }

        const clickVoucherLink = () => {
            console.log(landingFlow.states.purchase.iimmpactVoucherlink)
            if (landingFlow.states.purchase.iimmpactVoucherlink != '') {
                window.location.replace(landingFlow.states.purchase.iimmpactVoucherlink)
            }
        }

        const clickBack = () => {
            window.location.replace(route.query.return_url);
        }

        provide("Modal", modal)
        provide("LandingFlow", landingFlow)

        onMounted(() => {
            if (route.query?.locale != null) {
                switchLang(route.query?.locale);
            }
            init()
        })

        return {
            lbl,
            modal,
            immpact,
            landingFlow,
            title,
            clickVoucherLink,
            clickBack,
            isError
        }
    },
}
</script>
<template>
    <div class="font-main">
        <div class="mx-auto page">
            <div class="relative bg-primary-color text-secondary-color text-18 text-center font-bold py-5">
                <div>
                    {{title}}
                </div>
                <div class="absolute top-0 left-0 w-full flex pt-5 pl-5">
                    <div class="w-5">
                        <img @click="clickBack()" src="../assets/icon/ic_iim-arrow-back.svg"/>
                    </div>
                </div>
            </div>
            <div v-if="immpact.isLoaded">
                <div v-if="landingFlow.states.purchase.iimmpactVoucherlink != ''">
                    <div class="px-5">
                        <Picture :purchase="landingFlow.states.purchase"></Picture>
                        <DetailInfo :purchase="landingFlow.states.purchase"></DetailInfo>
                    </div>
                    <div class="wrapper-redeem-btn w-full fixed bottom-0 py-10 px-5 bg-white">
                        <button class="bg-primary-color text-secondary-color text-20 rounded-full w-full py-2.5"
                                @click="clickVoucherLink()">
                                {{lbl.iimmpact.history.button_check}}
                        </button>
                    </div>
                </div>
                <div v-else>
                    <div class="px-5">
                        <SerialDetail :purchase="landingFlow.states.purchase"></SerialDetail>
                        <Serial :purchase="landingFlow.states.purchase"></Serial>
                        <SerialCode :purchase="landingFlow.states.purchase"></SerialCode>
                    </div>
                </div>
            </div>
            <div v-if="isError">
                <div>
                    <div class="err-page flex flex-wrap content-center">
                        <div class="flex-auto">
                            <div class="w-20 mx-auto">
                                <img src="../assets/icon/ic-im-error.png"/>
                            </div>
                            <div class="text-center font-bold text-18 text-im-black-232323 pt-5">{{lbl.iimmpact.error.title}}</div>
                            <div class="text-center text-14 text-im-gray-767676 pt-3">{{lbl.iimmpact.error.msg}}</div>
                        </div>
                    </div>
                    <div class="wrapper-redeem-btn w-full fixed bottom-0 bg-white border-t-2">
                        <div class="text-im-gray-767676 text-center underline text-20 rounded-full w-full py-3 px-5"
                                @click="clickBack()">
                                {{lbl.iimmpact.error.btn}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modal" />
    </div>
</template>
<style lang="scss" >
    @import "../style/main.scss";
</style>
<style lang="scss" scoped>
    @import "../style/base/base.scss";
    .wrapper-redeem-btn {
        max-width: $max-width-mobile;
    }
    .err-page {
        min-height: calc(100vh - 110px);
    }
</style>
